module.exports = {"IDA_FACTORY":"0x1fCBa21173206b78ed57642ad78809d564Fb9ED5","AUSD":"0xe217f8939682C9c0070dAe5F95f0237b688C779B","START_BLOCK":1,"LENDING_POOL":"0x580d4fdc4bf8f9b5ae2fb9225d584fed4ad5375c","RESERVE":"0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee","A_TOKEN":"0xd483b49f2d55d2c53d32be6eff735cb001880f79","FUTURE_TOKEN":"0xd50BF42433D67B0cc5b3403b0d67a85BE92c8603","INTEREST_RATES_STRATEGY":"0xf1D910EB12055B2604EB12C9D9bdC3d0B770B103"}


//////////////////
// WEBPACK FOOTER
// ./src/blockchain/deployment.json
// module id = 1AFW
// module chunks = 1